import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';

import InputNumberCommon from '../InputNumber';
import InputCommon from '../Input';
import SelectCommon from '../Select';
import RadioGroupCommon from '../RadioGroup';

import { CSS_UID, calculateField, getLabelValue } from './index.utils';
import { fieldShape, paramShape } from './index.shape';
import { TypesFieldEnum } from '../../Utils/enum';

import './index.scss';

/**
 * Field component
 * @param props
 * @returns {XML}
 * @constructor
 */
const CalculatedCommon = props => {
  const {
    field: { name, value },
    componentCommon,
    disabled,
    eventEmitter,
    showError,
    existError,
    placeholder,
    param,
  } = props;
  const { operations, format, ...otherParam } = param;
  const [calculatedValue, setCalculatedValue] = useState(calculateField({ value, operations }));

  // Force recaculate if operations have changed (values for dependancy of other fields)
  useEffect(() => {
    setCalculatedValueLocal(value);
  }, [operations]);

  /**
   * Set calculatedValue
   * @param {*} calculatedValueLocal
   */
  const setCalculatedValueLocal = calculatedValueLocal => {
    const result = calculateField({ value: calculatedValueLocal, operations });
    setCalculatedValue(result);
  };

  let ComponentReact;

  switch (componentCommon) {
    case TypesFieldEnum.CHECKBOX:
      ComponentReact = RadioGroupCommon;
      break;
    case TypesFieldEnum.SELECTION:
      ComponentReact = SelectCommon;
      break;
    case TypesFieldEnum.NUMBER:
    case TypesFieldEnum.NUMERIC:
      ComponentReact = InputNumberCommon;
      break;
    case TypesFieldEnum.TEXT:
    default:
      ComponentReact = InputCommon;
  }

  return (
    <div style={{ flexWrap: 'nowrap', display: 'flex' }} className={cn(CSS_UID)}>
      <ComponentReact
        field={{ name, value }}
        disabled={disabled}
        showError={showError}
        existError={existError}
        placeholder={placeholder}
        eventEmitter={event => {
          setCalculatedValueLocal(event);
          eventEmitter(event);
        }}
        {...otherParam}
      />
      <div style={{ paddingTop: '10px', minWidth: '70px' }}>
        <span className={cn(`field-${CSS_UID}`, 'label')}>{getLabelValue(calculatedValue, format)}</span>
      </div>
    </div>
  );
};

CalculatedCommon.propTypes = {
  field: PropTypes.shape(fieldShape),
  componentCommon: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  existError: PropTypes.bool,
  showError: PropTypes.bool,
  eventEmitter: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  param: PropTypes.shape(paramShape),
};

CalculatedCommon.defaultProps = {
  field: {
    value: undefined,
  },
  existError: false,
  showError: false,
  disabled: false,
  placeholder: undefined,
  param: { operations: [], selection: [], format: {} },
};

export default CalculatedCommon;
